import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";

import { T, useT } from "@repo/transifex";
import { Button, DialogError, SettingsLayout, Time } from "~/components";
import { useDayFilter } from "~/hooks";
import { useOrders } from "~/hooks/queries/orders";
import { useAuth } from "~/providers/store/auth";
import { TransactionsList } from "~/components/Transactions/transactions-list";
import { OrdersSearchInput } from "~/components/Transactions/orders-search-input";

type LocationState =
  | {
      showBackButton?: boolean;
    }
  | undefined;

export const TransactionsPage = () => {
  const [searchString, setSearchString] = useState("");
  const location = useLocation();
  const showBackButton =
    (location.state as LocationState)?.showBackButton ?? false;

  const t = useT();

  const { tillId } = useAuth();

  const { start, end, label, handleNext, handlePrev } = useDayFilter();

  const {
    data: orders,
    status,
    refetch,
    isFetching
  } = useOrders({
    tillId: tillId ?? undefined,
    start,
    end,
    searchString
  });

  return (
    <SettingsLayout
      title={t("Transactions")}
      action={
        <div className="flex flex-1 items-center justify-end gap-5">
          <div className="w-1/3">
            <OrdersSearchInput onSearch={setSearchString} />
          </div>
          <Time label={label} onNext={handleNext} onPrev={handlePrev} />
        </div>
      }
      {...(showBackButton && {
        backUrl: "/pos"
      })}
      className="pb-0"
    >
      {status === "error" && (
        <DialogError error={t("Something went wrong")}>
          <Button onClick={() => refetch()} loading={isFetching}>
            <T _str="Retry" />
          </Button>
        </DialogError>
      )}
      <TransactionsList
        data={orders?.orders ?? []}
        isLoading={status === "pending"}
      />
      <Outlet />
    </SettingsLayout>
  );
};
